<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PageAlerts from "@/components/page-alerts";
import CustomLoader from "@/components/widgets/custom-loader";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import constants from "../../constants";

/**
 * Student's detail component
 */
export default {
  page: {
    title: "Student's Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, CustomLoader, PageAlerts },
  data() {
    return {
      productDetail: null,
      title: "Student's Details",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "View Students",
          href: "/students",
        },
        {
          text: "Students Details",
          active: true,
        },
      ],
      deleteStd: {
        studentId: "",
        reason: ""
      },
      data: {
        fee: "",
        amount: "",
        course: "",
      },
      filterData: {
        year: "",
        class: "",
        course: "",
      },
      filterDataProg: {
        year: "",
      },
      filteredReportDetails: [],
      position: 0,
      otherfeesID: "",
      sysConstants: constants,
      feesError: "",
      termError: "",
      amountError: "",
      enrollmentDets: {
        'tot':'',
        'course':'',
        'level':'',
        'year':'',
        'pbal':'',
        'add':'',
        'expt':'',
        'paid':'',
        'bal':'',
      },
    };
  },
  computed: {
    ...mapGetters("students", ["GetStudentDetails","GetStudentPerf","SaveStatus",]),
    ...mapGetters("fees", ["FeesItems", "OtherFees"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("marks", ["getYears","getStudentReport","getReportDetails","getFechingReports","getProgDetails",]),
    ...mapGetters("classes", ["AllClasses", "AllClassStreams"]),
  },
  watch: {
    
  },
  methods: {
    ...mapActions({
      FetchStudent: "students/fetchStudent",
      DeleteStudent: "students/deleteStudent",
      FetchStudentPerf: "students/fetchStudentPerf",
      FetchFeesItems: "fees/fetchItems",
      DeleteOtherFees: "fees/deleteOtherFees",
      FetchStreams: "classes/fetchStreams",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchClasses: "classes/fetchClasses",
      FetchYears: "marks/fetchYear",
      FetchStudentReport: "marks/fetchStudentReport",
      GenerateStdReport: "marks/generateStdReport",
      FetchAllProgDetails: "marks/fetchAllProgDetails",
    }),

    // fetchStreamsinClass(event) {
    //   const id = event.target.value;
    //   const classSelected = { id };
    //   //fetching class streams
    //   this.FetchClassStreams(classSelected);
    // },

    redirect() {
      this.$router.push(`/student/ledger/${btoa(this.$route.params.id)}`);
    },
    redirectStudentReport() {
      this.$router.push(`/student/report/`);
    },
    // generateStudentReport() {
    //   this.filterData.stdId = this.studentId;
    //   delete this.filterData.studentId;
    //   this.filterData.position = this.position[0];
    //   this.GenerateStdReport(this.filterData);
    // },
    // fetchAllProgDetails() {
    //   this.filterDataProg.sid = this.studentId;
    //   this.FetchAllProgDetails(this.filterDataProg);
    // },
    resetAddModal() {
      this.data = {
        fee: "",
        amount: "",
      };
      this.resetError();
    },
    resetError() {
      this.feesError = "";
      this.amountError = "";
    },
    deleteStudent(modal) {
      this.modal = modal;
      this.DeleteStudent(this.deleteStd);
      this.closeModal(modal);
    },
    setDetails(row) {
      this.enrollmentDets = row;
    },
    getStdId(id) {
      this.deleteStd.studentId = id;
    },
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },
    submitFilter() {
      this.filterData.studentId = this.deleteStd.studentId;
      this.FetchStudentReport(this.filterData);
    },
  },

  created() {
    this.FetchStudent(this.$route.params.id);
    this.FetchFeesItems();
    // this.FetchYears();
    // this.FetchClasses();
    // this.FetchStreams();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_students')
        )
      "
    >
      <CustomLoader v-if="SaveStatus" :loading="SaveStatus"></CustomLoader>
      <div v-else class="col-lg-12">
        <div class="card">
          <div class="card-body pt-1">
            <b-card class="mb-1 shadow-none">
              <b-card-body role="tab">
                <div class="row">
                  <div class="col-xl-3 col-md-3">
                    <div class="product-detai-imgs mb-2">
                      <div class="product-img">
                        <img
                          :src="
                            sysConstants.url +
                              'students/' +
                              GetStudentDetails.data.photo
                          "
                          alt="Student Image"
                          class="img-fluid mx-auto d-block"
                        />
                      </div>
                    </div>
                    <h5>
                      {{ GetStudentDetails.data.name }} <br>
                    </h5>
                    <h4>
                      <b
                        v-if="GetStudentDetails.data.status == 1"
                        class="text-success mt-2"
                        >Active</b
                      >
                      <b
                        v-else-if="GetStudentDetails.data.status == 2"
                        class="text-primary"
                        >Graduated</b
                      >
                      <b v-else class="text-danger">Left School</b>
                    </h4>
                    <div class="col-md-12 mb-4">
                      <b-button-group>
                        <router-link
                          v-if="GetStudentDetails.data.status == 1"
                          :to="`/students/edit/${this.$route.params.id}`"
                          role="button"
                          class="btn  btn-primary float-end"
                        >
                          <i class="fa fa-edit"></i>
                          Edit
                        </router-link>
                        <button
                          @click="redirect()"
                          role="button"
                          class="btn btn-success float-end"
                        >
                          <i class="fa fa-box"></i>
                          Ledger
                        </button>
                        <!-- <b-button size="sm" v-b-modal.add-other-fees>
                                <i class="fa fa-plus"></i> Fees
                              </b-button> -->
                      </b-button-group>
                    </div>
                  </div>
                  <div class="col-xl-9 col-md-9 row">
                    <div class="mt-3 col-md-6">
                      <h5>Accademic Details</h5>
                      <div class="row mb-2">
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-unlink
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>RegNo: </b>
                          DLS{{ GetStudentDetails.data.id }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-unlink
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>Course:</b>
                          {{ GetStudentDetails.data.course.name }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-unlink
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>Level:</b>
                          {{ GetStudentDetails.data.class.short }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-unlink
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>Gender:</b>
                          {{ GetStudentDetails.data.gender }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                                        bx bx-unlink
                                        font-size-16
                                        align-middle
                                        text-primary
                                        me-1
                                      "
                          ></i>
                          <b>D.O.B:</b> {{ GetStudentDetails.data.dob }}
                        </p>
                      </div>
                      <hr />
                      <h5>Other Details</h5>
                      <div class="row mb-2">
                        <p class="text-muted">
                          <i
                            class="
                                      bx bx-user-voice
                                      font-size-16
                                      align-middle
                                      text-primary
                                      me-1
                                    "
                          ></i>
                          <b>Occupation:</b>
                          {{
                            GetStudentDetails.data.occupation != null
                              ? GetStudentDetails.data.occupation
                              : "__"
                          }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                                        bx bx-unlink
                                        font-size-16
                                        align-middle
                                        text-primary
                                        me-1
                                      "
                          ></i>
                          <b>Contact(s):</b>
                          {{
                            GetStudentDetails.data.contact != null
                              ? GetStudentDetails.data.contact
                              : "__"
                          }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                                        bx bx-unlink
                                        font-size-16
                                        align-middle
                                        text-primary
                                        me-1
                                      "
                          ></i>
                          <b>Email :</b>
                          {{
                            GetStudentDetails.data.email == ""
                              ? "__"
                              : GetStudentDetails.data.email
                          }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="bx bx-user-voice font-size-16 align-middle text-primary me-1"
                          ></i>
                          <b>Address:</b>
                          {{
                            GetStudentDetails.data.address != null
                              ? GetStudentDetails.data.address
                              : "__"
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="mt-3 col-md-6">
                      <h5>Guardian/Parent's Details</h5>
                      <div class="row mb-2">
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-user-voice
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>Name:</b>
                          {{ GetStudentDetails.data.guardian }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-user-voice
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>Contacts :</b>
                          {{ GetStudentDetails.data.gcontacts }}
                        </p>
                        <p class="text-muted">
                          <i
                            class="
                              bx bx-user-voice
                              font-size-16
                              align-middle
                              text-primary
                              me-1
                            "
                          ></i>
                          <b>Email:</b>
                          {{ GetStudentDetails.data.gemail }}
                        </p>
                      </div>

                      <h5 class="">Place of Residence:</h5>
                      <p class="text-muted mb-4">
                        {{ GetStudentDetails.data.resident }}
                      </p>
                      <hr />
                      <h5
                        class="text-muted"
                        v-if="GetStudentDetails.data.status == 1"
                      >
                        Change Student's Status:
                      </h5>
                      <div
                        class="row mb-2"
                        v-if="GetStudentDetails.data.status == 1"
                      >
                        <h5 class="text-danger">
                          <i class="fas fa-exclamation-triangle"></i>
                          CAUTION !
                        </h5>
                        <p class="text-primary mb-4">
                          <b><u>Please note:</u></b> <br />
                          Clicking the button below, you confirm that the
                          student left the school.
                        </p>
                        <div class="col-md-12 mb-3">
                          <button
                            v-if="
                              getCurrentUser.permissions.find((item) =>
                                item.permission.includes('add_student')
                              )
                            "
                            v-b-modal.delete-student
                            @click="getStdId(GetStudentDetails.data.id)"
                            class="btn btn-outline-danger btn-sm float-start"
                          >
                            <i class="fas fa-trash-alt"></i>
                            Delete Student
                          </button>
                        </div>
                      </div>
                      <div
                        class="row mb-2"
                        v-else-if="GetStudentDetails.data.reason"
                      >
                        <h5>Status Reason</h5>
                        <p class="text-muted mb-4">
                          {{ GetStudentDetails.data.reason }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <!-- enrolment details -->
                  <div class="col-12 row">
                    <hr>
                    <h5>
                      <b>Enrolment Details </b>
                    </h5>
                    <div class="col-md-12 custom-vert">
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col">Count</th>
                            <th scope="col">Course</th>
                            <th scope="col">Level</th>
                            <th scope="col">Year</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(enrolmentData, enrolIndex) in GetStudentDetails.payments"
                            :key="enrolIndex"
                          >
                            <td scope="row">{{ enrolIndex + 1 }}</td>
                            <th>{{ enrolmentData.course }}</th>
                            <td>{{ enrolmentData.level }}</td>
                            <td>{{ enrolmentData.year }}</td>
                            <td>
                              <button @click="setDetails(enrolmentData)"
                                class="btn btn-sm btn-primary"
                                v-b-modal.details-modal
                              ><i class="fas fa-info-circle"></i> Details</button>
                            </td>
                          
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
            <b-modal
              id="delete-student"
              size="md"
              hide-footer
              @hidden="resetAddModal"
              v-if="
                getCurrentUser.permissions.find((item) =>
                  item.permission.includes('add_student')
                )
              "
            >
              <template #modal-title> Delete Student </template>
              <form @submit.prevent="deleteStudent('delete-student')">
                <div class="form-group mb-3">
                  <label>Reason for deleting <small class="text-danger">*</small></label>
                  <textarea
                    v-model="deleteStd.reason"
                    class="form-control"
                    :maxlength="200"
                    rows="3"
                    required
                    placeholder="Enter a reason for deleting this student"
                  ></textarea>
                </div>
                <PageAlerts
                  title="Do you want to delete this student ?"
                  primaryMsg="Please Note: This is a permanent action."
                  alertType="danger"
                />
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    data-dismiss="modal"
                    @click="closeModal('delete-student')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                  <button
                    type="submit"
                    size="sm"
                    disabled
                    class="btn btn-sm btn-outline-danger"
                    v-if="SaveStatus"
                  >
                    <b-spinner
                      variant="danger"
                      small
                      label="Deleting Data..."
                    ></b-spinner>
                    Deleting...
                  </button>
                  <button
                    v-else
                    type="submit"
                    size="sm"
                    class="btn btn-sm btn-outline-danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                    Confirm Deletion
                  </button>
                </div>
              </form>
            </b-modal>

            <b-modal
              id="details-modal"
              size="xl"
              hide-footer
            >
              <template #modal-title> View Enrollment Details For {{ enrollmentDets.course }} {{ enrollmentDets.level }} {{ enrollmentDets.year }}</template>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>Fees</th>
                    <th>Arrears</th>
                    <th>Additions</th>
                    <th>Exemptions</th>
                    <th>Payable</th>
                    <th>Paid</th>
                    <th>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ enrollmentDets.tot }}</td>
                    <td>{{ enrollmentDets.pbal }}</td>
                    <td>{{ enrollmentDets.add }}</td>
                    <td>{{ enrollmentDets.expt }}</td>
                    <td>{{ enrollmentDets.payable }}</td>
                    <td>{{ enrollmentDets.paid }}</td>
                    <td>{{ enrollmentDets.bal }}</td>
                  </tr>
                </tbody>
              </table>
              <hr>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Mode</th>
                    <th>Paid By</th>
                    <th>Receipt</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(paymt, index) in enrollmentDets.payments"
                            :key="index">
                    <td>{{ index+1 }}</td>
                    <td>{{ paymt.pdate }}</td>
                    <td>{{ paymt.amount }}</td>
                    <td>{{ paymt.mode }}</td>
                    <td>{{ paymt.paidby }}</td>
                    <td>{{ paymt.receipt }}</td>
                  </tr>
                </tbody>
              </table>
              <hr>
              <h4>Student Results</h4>
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <th>No</th>
                    <th v-for="(result, index) in enrollmentDets.results"
                            :key="index">{{result.subject}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td v-for="(result, index) in enrollmentDets.results"
                            :key="index">{{ result.mark }}</td>
                  </tr>
                </tbody>
              </table>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    data-dismiss="modal"
                    @click="closeModal('details-modal')"
                  >
                    <i class="fa fa-times"></i> Close
                  </button>
                </div>
            </b-modal>

          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
